import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { oauthLogin } from 'src/api/netdocs';
import { clientId } from 'src/services/authProvider';

function addOrReplaceLocalStorageItem(key, value) {
  if (localStorage.getItem(key)) {
    localStorage.removeItem(key);
  }
  localStorage.setItem(key, value);
}
// Need to intercept net docs query params from redirect before jumping into MSAL auth
// We handle 2 response params, code and error. These are added to the local storage
// so that they can persist through the MSAL redirect. Once we navigate back from Azure AD
// a render is triggered, and then the AAD token and netdocs token will/should be in local storage
// so we then fire off the oauthLogin request and attempt to login.
// If netdocs return us a error query param then we display an error toast.
function NetDocumentsAuth(props) {
  const { enqueueSnackbar } = useSnackbar();
  const urlParams = new URLSearchParams(window.location.search);

  const netDocsAuthCode = urlParams.get('code');
  const netDocsErrorCode = urlParams.get('error');

  const netdocsAuthCodeKey = 'netdocs.authCode';
  const netdocsErrorCodeKey = 'netdocs.errorCode';

  useEffect(() => {
    if (netDocsAuthCode) {
      addOrReplaceLocalStorageItem(netdocsAuthCodeKey, netDocsAuthCode);
    }
    if (netDocsErrorCode) {
      addOrReplaceLocalStorageItem(netdocsErrorCodeKey, netDocsErrorCode);
    }
  }, [netDocsAuthCode, netDocsErrorCode]);

  // watch local storage for both Azure AD and netdocs tokens
  // if we have both we are likely logging into netdocs so send a login request
  useEffect(() => {
    const aad = localStorage.getItem('msal.idtoken') || localStorage.getItem(`msal.${clientId}.idtoken`);
    const netdocsCode = localStorage.getItem(netdocsAuthCodeKey);
    const netdocsError = localStorage.getItem(netdocsErrorCodeKey);

    if (aad && netdocsCode) {
      localStorage.removeItem(netdocsAuthCodeKey);
      oauthLogin(netdocsCode)
        .then(() => {
          enqueueSnackbar('Successfully authorized NetDocuments', {
            variant: 'success'
          });
        }, () => {
          enqueueSnackbar('Unable to login to NetDocuments', {
            variant: 'error'
          });
        });
    }
    if (netdocsError) {
      localStorage.removeItem(netdocsErrorCodeKey);
      let message = 'Unexpected Error occurred while authorizing with NetDocuments';

      if (['access_denied', 'unauthorized'].indexOf(netdocsError) >= 0) {
        message = 'Unable to authorize user with NetDocuments';
      }

      enqueueSnackbar(message, {
        variant: 'error'
      });
    }
  });

  return props.children;
}

NetDocumentsAuth.propTypes = {
  children: PropTypes.any
};

export default NetDocumentsAuth;
